import { PropsWithChildren, memo, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface EfasLinkI {
    href: string
    target?: string
    children: ReactNode
    className?: string
    testid?: string

}

export default memo(function EfasLink(props: PropsWithChildren<EfasLinkI>) {
    return (<Link data-testid={props.testid} to={props.href} className={`link-offset-2 link-underline-opacity-25 ${props.className}`} target={props.target}>{props.children}</Link>);
});